/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SelectLegalDialogMain.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Grid } from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import SelectLegalStandard from "./SelectLegalStandard";
import CommonBreadcrumbs from "../../../../components/customComponentsV2/common/Breadcrumbs/CommonBreadcrumbs";
import CustomToolTip from "../../../../components/infoButton/CustomToolTip";

function SelectLegalDialogMain({
  setSelectedLegal,
  displayPageMap,
  displayPage,
  setDisplayPage,
  selectedLegal,
  savedLinkages,
  disableLrRadioButton,
  disabledLegalRequirement = [],
  shouldShowLegalRequirementLinkedInfo = () => false,
  selectedStandard,
  setSelectedStandard,
  selectedChapter,
  setSelectedChapter,
  selectedLegalStandard,
  setSelectedLegalStandard,
  legalChapterList,
  setLegalChapterList,
  isAISuggested = false,
  aiRecommendedEntities = [],
}) {
  const [componentType, setComponentType] = useState("all");
  return (
    <Box>
      <Grid container>
        <Grid item sm={12} sx={{ mb: 1 }}>
          <CommonBreadcrumbs
            color={"black"}
            fontSize={12}
            items={[
              ...(displayPage === displayPageMap?.ls
                ? [
                    {
                      label: "Select Legal Standard",
                    },
                  ]
                : []),
              ...(displayPage === displayPageMap?.lc
                ? [
                    {
                      label: (
                        <CustomToolTip length={10}>
                          {selectedStandard}
                        </CustomToolTip>
                      ),
                      ...(!selectedLegal || selectedLegal.length === 0
                        ? {
                            onClick: () => {
                              setDisplayPage(displayPageMap?.ls);
                            },
                          }
                        : {}),
                    },
                    {
                      label: "Select Legal Chapter",
                    },
                  ]
                : []),
              ...(displayPage === displayPageMap?.lr
                ? [
                    {
                      label: (
                        <CustomToolTip length={10}>
                          {selectedStandard}
                        </CustomToolTip>
                      ),
                      ...(!selectedLegal || selectedLegal.length === 0
                        ? {
                            onClick: () => {
                              setDisplayPage(displayPageMap?.ls);
                            },
                          }
                        : {}),
                    },
                    {
                      label: (
                        <CustomToolTip length={10}>
                          {selectedChapter}
                        </CustomToolTip>
                      ),
                      onClick: () => {
                        setDisplayPage(displayPageMap?.lc);
                      },
                    },
                    {
                      label: "Select Legal Requirement",
                    },
                  ]
                : []),
            ]}
          />
        </Grid>

        <Grid item sm={12}>
          <SelectLegalStandard
            // disableLrRadioButton={disableLrRadioButton}
            savedLinkages={savedLinkages}
            componentType={componentType}
            setComponentType={setComponentType}
            setSelectedLegal={setSelectedLegal}
            displayPage={displayPage}
            displayPageMap={displayPageMap}
            setDisplayPage={setDisplayPage}
            selectedLegal={selectedLegal}
            // disabledLegalRequirement={disabledLegalRequirement}
            shouldShowLegalRequirementLinkedInfo={
              shouldShowLegalRequirementLinkedInfo
            }
            selectedStandard={selectedStandard}
            setSelectedStandard={setSelectedStandard}
            selectedChapter={selectedChapter}
            setSelectedChapter={setSelectedChapter}
            selectedLegalStandard={selectedLegalStandard}
            setSelectedLegalStandard={setSelectedLegalStandard}
            legalChapterList={legalChapterList}
            setLegalChapterList={setLegalChapterList}
            aiRecommendedEntities={aiRecommendedEntities}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

SelectLegalDialogMain.propTypes = {
  setSelectedLegal: PropTypes.func,
  displayPageMap: PropTypes.shape({
    ls: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lr: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  displayPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setDisplayPage: PropTypes.func,
  selectedLegal: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  savedLinkages: PropTypes.array,
  disableLrRadioButton: PropTypes.bool,
  disabledLegalRequirement: PropTypes.array,
  shouldShowLegalRequirementLinkedInfo: PropTypes.func,
  selectedStandard: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSelectedStandard: PropTypes.func,
  selectedChapter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSelectedChapter: PropTypes.func,
  selectedLegalStandard: PropTypes.object,
  setSelectedLegalStandard: PropTypes.func,
  legalChapterList: PropTypes.array,
  setLegalChapterList: PropTypes.func,
  isAISuggested: PropTypes.bool,
  aiRecommendedEntities: PropTypes.array,
};

export default SelectLegalDialogMain;
